"use strict"
import axios from "axios";

const getDefaultState = () => {
  return {
    shops: [],
    shopsLoading: false,
    typicalVacancies: []
  }
}

const state = getDefaultState();

const getters = {
  getShopsForSelect: state => {
    const shops = state.shops.map(x => {
      return { id: x.id, name: x.name };
    });

    if (shops.length <= 1) {
      return [shops[0]];
    }

    return shops;
  },

  getShopById: state => id => {
    return state.shops.find(x => x.id === id);
  },

  // геттер исключающий вакансии которые уже введны для данного магазина
  typicalVacanciesExclude: state => shopId => {
    const currentShop = state.shops.find(x => x.id === shopId);
    const vacanciesToExclude = currentShop.salaries.map(x => x.vacancy.id);

    return state.typicalVacancies
      .filter(x => {
        if(!vacanciesToExclude.includes(x.id)) {
          return true;
        }
        return false;
      })
      .map(x => { return { id: x.id, name: x.name } });
  }
};

const mutations = {
  SET_SHOPS_LOADING: (state, payload) => {
    state.shopsLoading = payload;
  },

  SET_SHOPS: (state, payload) => {
    state.shops = payload;
  },

  SET_TYPICAL_VACANCIES: (state, payload) => {
    state.typicalVacancies = payload;
  },
};

const actions = {
  async fetchAllShops({ commit, dispatch }) {
    commit("SET_SHOPS_LOADING", true);

    await dispatch('fetchShops');
    await dispatch('fetchVacancies')
  },

  async fetchShops({ commit }) {
    if (!state.shopsLoading) {
      commit("SET_SHOPS_LOADING", true);
    }

    await axios.get(`/1.0/spec-private/sportmaster/shops`)
      .then(x => {
        commit("SET_SHOPS", x.data.data);
      })
      .finally(() => {
        commit("SET_SHOPS_LOADING", false);
      })
  },

  async fetchVacancies({ commit }) {
    if (!state.shopsLoading) {
      commit("SET_SHOPS_LOADING", true);
    }

    await axios.get(`/1.0/spec-public/sportmaster/landing/vacancies`)
      .then(x => {
        commit("SET_TYPICAL_VACANCIES", x.data.data);
      })
      .finally(() => {
        commit("SET_SHOPS_LOADING", false);
      })
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
